/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DateRangeValue } from './date-range-value';
import { KpiValueFormat } from './kpi-value-format';
import { KpiStatus } from './kpi-status';
import { TrendPlan } from './trend-plan';
import { PeriodComparison } from './period-comparison';
import { ResultFreshness } from './result-freshness';
import { TileLocalizedTitleDto } from './tile-localized-title-dto';


export interface TileRenderResultDto { 
    /**
     * Dashboard item id for this render result.
     */
    itemId: string;
    /**
     * KPI definition id rendered by this dashboard item.
     */
    kpiId: string;
    /**
     * KPI version used for this tile, or null when no served version exists.
     */
    resolvedVersionId?: string | null;
    /**
     * Queued query execution id when this tile rendered successfully.
     */
    executionId?: string;
    /**
     * Per-tile render error. One failed tile does not fail the whole dashboard render.
     */
    error?: string;
    /**
     * Item sort order within the dashboard.
     */
    order?: number;
    /**
     * Optional display title override for the tile, in English.
     */
    titleOverride?: string;
    /**
     * The item\'s i18n. The tile\'s title override in languages other than English, keyed by two-letter lowercase language code, at most 20 languages, for example {\"de\": {\"titleOverride\": \"Neue Mitglieder\"}, \"cs\": {\"titleOverride\": \"Noví členové\"}}. English goes in the plain titleOverride; an en key is rejected. A client shows the entry for the viewer\'s language, else the plain titleOverride. With neither, the tile shows the KPI title from i18n in the viewer\'s language. Null when there are no translations.
     */
    tileI18n?: { [key: string]: TileLocalizedTitleDto; } | null;
    /**
     * KPI display type (count, amount, percentage, trend, chart).
     */
    type?: string;
    /**
     * How a trend KPI\'s values are formatted; null for every other type.
     */
    valueFormat?: KpiValueFormat | null;
    /**
     * Localized KPI labels/descriptions keyed by locale. The tile\'s own title translations are in tileI18n.
     */
    i18n?: object;
    /**
     * Chart configuration for chart-type KPIs.
     */
    chartConfig?: object | null;
    /**
     * KPI SQL, used for super-admin tooltips.
     */
    sql?: string;
    /**
     * KPI configuration status (ok | needs_reconfiguration).
     */
    configurationStatus?: string;
    /**
     * Lifecycle status of the KPI behind this tile. When it is archived the tile is not executed and carries neither executionId nor error. Absent when the tile points at a KPI this program no longer has, which is also what the tile\'s error reports.
     */
    kpiStatus?: KpiStatus;
    /**
     * A trend tile\'s plan: which bucket is the headline, which it is compared with and which is unfinished. Match execution rows to a bucket by the first 10 characters of their bucket column. Null on every other tile; absent when the tile failed before planning.
     */
    trend?: TrendPlan | null;
    /**
     * What the tile\'s period parameter resolved to (for a trend tile, before widening to its window; with a comparison, cut at today); an open end is null on that side. Null when the KPI has no period parameter; absent when the tile failed before planning.
     */
    period?: DateRangeValue | null;
    /**
     * Machine-readable reason for error, for the client to translate (errorMessages.<CODE>). KPI_TREND_FORMAT_OUTDATED: the tile\'s trend KPI still has the retired single-value SQL and needs a new version returning bucket and value. DASHBOARD_DATE_RANGE_TOO_LARGE: a chart grouped by time got dates without a start or with more than 1000 points; the error names a range to pick instead. Absent when the error has no code.
     */
    errorCode?: TileRenderResultDto.ErrorCodeEnum;
    /**
     * fresh: the tile\'s rows were computed inside the cache window. stale: an older result served at once while one background refresh runs; show computedAt as \"as of\". computing: the query is queued or running; poll executionId.
     */
    freshness?: ResultFreshness;
    /**
     * When a cached tile result was computed, for an \"as of\" label.
     */
    computedAt?: string;
    /**
     * How long the latest warehouse run of the tile\'s KPI version took, in milliseconds; absent until it has run.
     */
    lastRunMs?: number;
    /**
     * True when that latest run took 5 s or more, so the tile can say it takes a while to load.
     */
    slow?: boolean;
    /**
     * Compare to on a count, amount or percentage tile: the compared dates, how to show the change and the second run\'s executionId. Null when there is nothing to compare: Compare to is off, the tile is a trend or chart, it is not bound to a date filter, its KPI has no date range there, or the range has no start or starts after today. Absent when the tile has an error or its KPI is archived.
     */
    comparison?: PeriodComparison | null;
}
export namespace TileRenderResultDto {
    export const ErrorCodeEnum = {
        DashboardNotFound: 'DASHBOARD_NOT_FOUND',
        KpiNotFound: 'KPI_NOT_FOUND',
        KpiAlreadyExists: 'KPI_ALREADY_EXISTS',
        KpiKeyAlreadyExists: 'KPI_KEY_ALREADY_EXISTS',
        KpiNameAlreadyExists: 'KPI_NAME_ALREADY_EXISTS',
        ProgramKpiNotFound: 'PROGRAM_KPI_NOT_FOUND',
        KpiExecutionNotFound: 'KPI_EXECUTION_NOT_FOUND',
        KpiExecutionFailed: 'KPI_EXECUTION_FAILED',
        KpiQueryTimeout: 'KPI_QUERY_TIMEOUT',
        KpiQuerySyntaxError: 'KPI_QUERY_SYNTAX_ERROR',
        DwhConnectionNotFound: 'DWH_CONNECTION_NOT_FOUND',
        DwhConnectionAlreadyExists: 'DWH_CONNECTION_ALREADY_EXISTS',
        DwhUnreachable: 'DWH_UNREACHABLE',
        DwhTableNotFound: 'DWH_TABLE_NOT_FOUND',
        AiCompletionNotFound: 'AI_COMPLETION_NOT_FOUND',
        DashboardFilterValueInvalid: 'DASHBOARD_FILTER_VALUE_INVALID',
        DashboardFilterUnknownField: 'DASHBOARD_FILTER_UNKNOWN_FIELD',
        DashboardFilterBindingInvalid: 'DASHBOARD_FILTER_BINDING_INVALID',
        DashboardDateRangeTooLarge: 'DASHBOARD_DATE_RANGE_TOO_LARGE',
        DashboardArchived: 'DASHBOARD_ARCHIVED',
        DashboardInvalidStatusTransition: 'DASHBOARD_INVALID_STATUS_TRANSITION',
        DashboardNotDeletable: 'DASHBOARD_NOT_DELETABLE',
        KpiArchived: 'KPI_ARCHIVED',
        KpiNotDeletable: 'KPI_NOT_DELETABLE',
        KpiInUse: 'KPI_IN_USE',
        KpiTrendFormatOutdated: 'KPI_TREND_FORMAT_OUTDATED',
        DashboardBundleInvalid: 'DASHBOARD_BUNDLE_INVALID',
        DashboardBundleUnsupportedVersion: 'DASHBOARD_BUNDLE_UNSUPPORTED_VERSION',
        KpiBundleInvalid: 'KPI_BUNDLE_INVALID',
        KpiBundleUnsupportedVersion: 'KPI_BUNDLE_UNSUPPORTED_VERSION',
        KpiImportFailed: 'KPI_IMPORT_FAILED',
        DashboardExportKeyConflict: 'DASHBOARD_EXPORT_KEY_CONFLICT',
        DashboardImportFailed: 'DASHBOARD_IMPORT_FAILED',
        DashboardViewNotFound: 'DASHBOARD_VIEW_NOT_FOUND',
        DashboardItemNotFound: 'DASHBOARD_ITEM_NOT_FOUND',
        DashboardReorderInvalid: 'DASHBOARD_REORDER_INVALID',
        KpiVersionNotFound: 'KPI_VERSION_NOT_FOUND',
        KpiConfigurationInvalid: 'KPI_CONFIGURATION_INVALID',
        KpiParameterInvalid: 'KPI_PARAMETER_INVALID',
        KpiInvalidStatusTransition: 'KPI_INVALID_STATUS_TRANSITION',
        KpiNotCloneable: 'KPI_NOT_CLONEABLE',
        KpiNotPublished: 'KPI_NOT_PUBLISHED',
        ArtifactNotFound: 'ARTIFACT_NOT_FOUND',
        ArtifactConfigurationInvalid: 'ARTIFACT_CONFIGURATION_INVALID',
        QueryRejected: 'QUERY_REJECTED',
        KpiLimitReached: 'KPI_LIMIT_REACHED',
        DashboardFilterTooManyOptions: 'DASHBOARD_FILTER_TOO_MANY_OPTIONS',
        QueryTimeout: 'QUERY_TIMEOUT',
        QueryCancelled: 'QUERY_CANCELLED',
        ArtifactExecutionMismatch: 'ARTIFACT_EXECUTION_MISMATCH',
        ArtifactQueryTooSlow: 'ARTIFACT_QUERY_TOO_SLOW',
        InternalServerError: 'INTERNAL_SERVER_ERROR',
        NotAuthorized: 'NOT_AUTHORIZED',
        Forbidden: 'FORBIDDEN',
        ValidationFailed: 'VALIDATION_FAILED',
        ProgramContextMissing: 'PROGRAM_CONTEXT_MISSING',
        OrganizationNotFound: 'ORGANIZATION_NOT_FOUND',
        ResourceNotFound: 'RESOURCE_NOT_FOUND',
        ResourceConflict: 'RESOURCE_CONFLICT'
    } as const;
    export type ErrorCodeEnum = typeof ErrorCodeEnum[keyof typeof ErrorCodeEnum];
}


